import {
  ThemeProvider,
  Button as DefaultButton
} from '@ui-propulsion/react-components';
import React from 'react';
import PropTypes from 'prop-types';

export const Button = ({ children = null, ...props }) => (
  <ThemeProvider>
    <DefaultButton {...props}>{children}</DefaultButton>
  </ThemeProvider>
);

Button.propTypes = {
  children: PropTypes.node.isRequired
};

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/shared_modules/propulsion/components/Button/Button.scss');